import axios from "axios";

// Production: REACT_APP_API_URL=https://your-api-host/api
export const API_BASE_URL = (process.env.REACT_APP_API_URL || "https://api.findautoparts.com.au/api/").replace(/\/$/, "");
// export const API_BASE_URL = (process.env.REACT_APP_API_URL || "http://localhost:5000/api").replace(/\/$/, "");
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "");
// Uploaded files (photos, voice notes, PDFs...) live on the Hostinger site.
// REACT_APP_FILES_URL=https://your-hostinger-domain  — falls back to the API host.
export const FILES_ORIGIN = (process.env.REACT_APP_FILES_URL || API_ORIGIN).replace(/\/$/, "");
export const assetUrl = (value) => !value ? "" : /^(https?:|blob:|data:)/i.test(value) ? value : `${FILES_ORIGIN}/${String(value).replace(/^\//, "")}`;

const api = axios.create({ baseURL: API_BASE_URL, timeout: 30000 });
const UPLOAD_TIMEOUT = 180000;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // File uploads: let the browser set "multipart/form-data; boundary=..." itself
  // (a manual or default JSON Content-Type breaks multer on the server) and give
  // big photo / voice uploads far longer than the 30s used for normal calls.
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    if (config.headers?.delete) config.headers.delete("Content-Type");
    else if (config.headers) delete config.headers["Content-Type"];
    if (!config.timeout || config.timeout < UPLOAD_TIMEOUT) config.timeout = UPLOAD_TIMEOUT;
  }
  return config;
});

const AUTH_PAGES = ["/login", "/user/login", "/admin/login", "/register"];
api.interceptors.response.use((response) => response, (error) => {
  const url = String(error.config?.url || "");
  const isAuthCall = /\/auth\/(login|register)/.test(url);
  if (error.response?.status === 401 && !isAuthCall && localStorage.getItem("token")) {
    let wasStaff = false;
    try { wasStaff = ["admin", "worker"].includes(JSON.parse(localStorage.getItem("user") || "null")?.role); } catch { /* ignore */ }
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("fcmToken");
    if (!AUTH_PAGES.includes(window.location.pathname.toLowerCase())) {
      window.location.assign(wasStaff ? "/admin/login" : "/user/login");
    }
  }
  return Promise.reject(error);
});
export default api;
